export default "__VITE_ASSET__C5Jlcy1C__"